import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this really for absolute beginners with no private practice experience?',
  a: 'Yes. The system is designed for students and professionals starting from zero. We begin with the clinical foundation and build everything step by step into a complete, ready-to-use practice workflow.'
}, {
  q: 'Can I learn even if I am not tech-savvy?',
  a: 'Absolutely. The visual method is straightforward and ready to use. Everything is delivered in PDF, so you only need a phone, tablet or computer to open it.'
}, {
  q: 'Are the templates actually useful for real patients?',
  a: 'Yes, they are based on real clinical practice standards. Intake forms, medical history logs, anthropometric trackers and meal plan structures are ready to print or fill in digitally.'
}, {
  q: 'How soon will I see real results in my workflow?',
  a: 'Most professionals report saving time from their very first consultation. The modular meal planning system alone replaces hours of manual work per patient.'
}, {
  q: 'Do I need expensive software to use this?',
  a: 'No. You can run this entire system with free or very low-cost digital tools. Volume 6 and the Rapid Setup Checklist include our recommendations.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-57" data-mp="11wgx4adxb2uh">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-58" data-mp="16o7a6o48w4pl">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-59" data-mp="s042naak0kyo">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-60" data-mp="ww1hfc665j9c">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-61" data-mp="mz6l8zxdbuy8" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-62" data-mp="2pmn6e1082429">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-63" data-mp="2axqyc3y60r1n">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-64" data-mp="38lhif28awqeq" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-65" data-mp="38k6i5ce2e0sd" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-66" data-mp="33npq473qv2a0">
                  <div className="overflow-hidden" data-id="element-67" data-mp="2um9gw2oo167d">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-68" data-mp="2ulgjhsbljt1w">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}